export const fetchCollaborators = data => ({
  type: "FETCH_COLLABORATORS",
  payload: data
});

export const setSearchNameCollaborator = searchWord => ({
  type: "SET_SEARCH_WORD",
  searchWord
});

export const setCollaboratorPaginationPage = pageNumber => {
  return {
    type: "SET_COLLABORATORS_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setYearFilterCollaborators = value => {
  return {
    type: "SET_YEAR_FILTER_COLLABORATORS",
    value
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/collaborator.js